import React from 'react';
import { useParams } from 'react-router-dom';
import { Spinner } from '@openedx/paragon';
import { useIntl } from '@edx/frontend-platform/i18n';

import { usePathwayById } from './usePathwayById';
import PathwayView from './PathwayView';
import messages from './messages';

import './index.scss';

const Pathways = () => {
  const intl = useIntl();
  const { pathwayId: rawPathwayId } = useParams();
  const pathwayId = decodeURIComponent(rawPathwayId || '');

  const {
    pathway, components, progressPercent, completedCount, resumeComponent, loading, error,
  } = usePathwayById(pathwayId);

  if (loading && !pathway) {
    return (
      <div className="pathway-inner__state">
        <Spinner
          animation="border"
          screenReaderText={intl.formatMessage(messages.loadingPathway)}
        />
      </div>
    );
  }

  if (error || !pathway) {
    return (
      <div className="pathway-inner__state pathway-inner__state--error">
        {intl.formatMessage(messages.pathwayLoadError)}
      </div>
    );
  }

  return (
    <PathwayView
      pathway={pathway}
      components={components}
      progressPercent={progressPercent}
      completedCount={completedCount}
      resumeComponent={resumeComponent}
    />
  );
};

export default Pathways;
